import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useHourlyDistribution } from '@hooks/dashboard/useKapi';

const OrdersByHour: React.FC = () => {
  const { data, isLoading } = useHourlyDistribution();

  if (isLoading) return <div className="chart-loading">Loading...</div>;

  const chartData = data && data.length > 0
    ? data.map(d => ({ hour: `${d.hour}:00`, orders: d.orderCount }))
    : Array.from({ length: 24 }, (_, i) => ({ hour: `${i}:00`, orders: 0 }));

  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="hourlyGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#06B6D4" stopOpacity={0.2} />
            <stop offset="95%" stopColor="#06B6D4" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false} />
        <XAxis dataKey="hour" tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} interval={2} />
        <YAxis tick={{ fontSize: 10, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12 }} />
        <Area type="monotone" dataKey="orders" stroke="#06B6D4" fill="url(#hourlyGrad)" strokeWidth={2} dot={false} activeDot={{ r: 4, fill: '#06B6D4', stroke: '#fff', strokeWidth: 2 }} />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default OrdersByHour;
